"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepLabel = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var VFlow_1 = require("../VFlow");
var Text_1 = require("../Text");
var useStepperContext_1 = require("./useStepperContext");
function StepLabel(props) {
    var status = props.status, title = props.title, subtitle = props.subtitle, style = props.style, rest = __rest(props, ["status", "title", "subtitle", "style"]);
    var direction = useStepperContext_1.useStepperContext().direction;
    var _a = styles_1.useStyles(createStyles, status), classes = _a.classes, css = _a.css;
    return (react_1.default.createElement("span", __assign({ className: css(style) }, rest),
        react_1.default.createElement(VFlow_1.VFlow, { vSpacing: direction === 'horizontal' ? 0.5 : 0 },
            react_1.default.createElement(Text_1.Text, { style: classes.label }, title),
            subtitle && react_1.default.createElement(Text_1.Text, null, subtitle))));
}
exports.StepLabel = StepLabel;
var createStyles = function (theme, status) { return ({
    label: {
        color: getLabelColor(status, theme),
        fontWeight: 'bold',
        transition: 'all .4s ease',
    },
}); };
var getLabelColor = function (status, theme) {
    if (status === 'active')
        return theme.pallete.primary.main;
    if (status === 'inactive')
        return theme.pallete.text.disabled;
    return theme.pallete.text.main;
};
//# sourceMappingURL=StepLabel.js.map